import { render, staticRenderFns } from "./quyuxinzeng.vue?vue&type=template&id=d9f68dc0"
import script from "./quyuxinzeng.vue?vue&type=script&lang=js"
export * from "./quyuxinzeng.vue?vue&type=script&lang=js"
import style0 from "./quyuxinzeng.vue?vue&type=style&index=0&id=d9f68dc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports